const BusinessRulesStorage = {
  formFields: [
    {
      name: 'Name',
      parameterName: 'name',
      type: 'text',
      placeHolder: 'Enter the business rule name',
      isRequired: true,
      maxLength: 99,
    },
    {
      name: 'Description',
      parameterName: 'description',
      type: 'text',
      placeHolder: 'Enter the description',
      isRequired: true,
    },
  ],

  roles: [
    { id: 1, value: 'Super Admin' },
    { id: 2, value: 'Organisation Admin' },
    { id: 3, value: 'Organisation User' },
  ],

  types: [
    { id: 1, value: 'Channel' },
    { id: 2, value: 'Organisation' },
  ],

  // Business Rule Type Enum
  BusinessRuleTypeEnum: {
    1: 'Channel',
    2: 'Organisation',
    Channel: 1,
    Organisation: 2,
  },
};

export default BusinessRulesStorage;
